import { render } from "./MessageTemplateEditor.vue?vue&type=template&id=d771c2c8"
import script from "./MessageTemplateEditor.vue?vue&type=script&lang=js"
export * from "./MessageTemplateEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__